import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate',
  standalone: true
})
export class TruncatePipe implements PipeTransform {
  transform(value: string, limit = 25,   
 ellipsis = '...'): string {
    if (value.length > limit) {
      return value.substring(0, limit) + ellipsis;
    } else {
      return value;
    }
  }
}

